import { CustomValuesEditField } from "PFApp/components/custom_values_edit_field";
import { Profile } from "PFCore/types";
import { ActivityPureCustomValue, CustomType, PureCustomValueData } from "PFTypes";

type ExperienceCustomTypeFieldProps = {
  customType: CustomType;
  tip: string;
  values: ActivityPureCustomValue[];
  errors?: string | string[];
  adminPage: boolean;
  profile: Profile;
  isMulti?: boolean;
  onChange: (values: PureCustomValueData[]) => void;
};

export const ExperienceCustomTypeField = ({
  customType,
  tip,
  values,
  errors,
  adminPage,
  profile,
  isMulti,
  onChange
}: ExperienceCustomTypeFieldProps) => (
  <CustomValuesEditField
    label={customType.display_as}
    tip={tip}
    customType={customType}
    values={values}
    qaIdPrefix="profile-internal-experience"
    errors={errors}
    adminPage={adminPage}
    multi={isMulti}
    profile={profile}
    handleChange={onChange}
  />
);
